import Store from '@/store'
import { UserModel } from '@/models/UserHierarchy'
import OrderModel from '@/models/OrderModel'
import FieldTypes from '@/constants/FieldTypes'
import addClassesToModelHeaders from '@/utils/addClassesToModelHeaders'

export class CustomerModel extends UserModel {
  static entity = 'customers'
  static baseEntity = 'users'

  static nameSingular = 'Customer'
  static namePlural = 'Customers'

  static fields() {
    return {
      ...super.fields(),
      is_merchant: this.boolean(false),
      is_super_admin: this.boolean(false),
      family_discount: this.attr().nullable(),
      payment_service: this.string().nullable(),
      payment_handle: this.string().nullable(),
      notes: this.string().nullable(),
      orders: this.hasMany(OrderModel),
      loadedCustomerShopDataForId: this.attr().nullable(),
    }
  }

  static field_headers() {
    let headers = [
      {
        text: 'Last Name',
        align: 'start',
        sortable: true,
        value: 'last_name',
        sticky: true,
      },
      {
        text: 'First Name',
        sortable: true,
        value: 'first_name',
      },
      { text: 'Email', value: 'email', sortable: true, width: 250 },
      {
        text: 'Family Discount',
        value: 'family_discount',
        formatted_value: 'family_discount_pcnt',
        sortable: true,
        align: 'center',
        type: FieldTypes.NUMBER,
      },
      { text: 'Phone', value: 'phone', sortable: true, width: 150 },
      { text: 'Address', value: 'address', width: 200 },
      { text: 'Payment Service', value: 'payment_service', sortable: true },
      { text: 'Payment Handle', value: 'payment_handle', sortable: true },
      { text: 'Notes', value: 'notes', align: 'center' },
    ]
    return addClassesToModelHeaders(headers)
  }

  static index_table_config() {
    return {
      dense: true,
      addable: false,
      removeable: false,
    }
  }

  get family_discount_pcnt() {
    return this.family_discount ? `${this.family_discount}%` : ''
  }

  get full_name() {
    let nameParts = [this.first_name, this.last_name].filter((name) => !!name)
    return nameParts.length
      ? nameParts.join(' ')
      : `Customer ${this.id} (Unnamed)`
  }

  get address() {
    if (!this.street && !this.zip) {
      return null
    }
    return `${this.street || '(Missing Street)'}, ${this.zip ||
      '(Missing Zip)'}`
  }

  static updateModel(id, fields) {
    const shopId = Store.getters['shop/getShopId']
    if (!shopId) {
      return Promise.reject('Shop must be defined to update Customer')
    }
    return this.api().patch(`/shops/${shopId}/customers/${id}`, fields, {
      dataTransformer: (response) => {
        return response.data.data
      },
    })
  }

  static updateSelf(id, fields) {
    return this.api().patch(`/customers/${id}`, fields, {
      dataTransformer: (response) => {
        return response.data.data
      },
    })
  }

  static fetchShopCustomerData(customerId, shopId) {
    shopId = shopId || Store.getters['shop/getShopId']
    return this.api().get(`/shops/${shopId}/customers/${customerId}`, {
      dataTransformer: (response) => {
        response.data.data.is_logged_in = true
        response.data.data.loadedCustomerShopDataForId = shopId
        return response.data.data
      },
    })
  }
}
export default CustomerModel
